import { all, call, put, select, takeEvery } from 'redux-saga/effects';
import { ScenarioPlayerActions } from './scenarioPlayerActions.ts';
import { AudioChatActions } from 'app/store/AudioChat/audioChatActions.ts';


function* resetTranscriptSaga() {
  yield put(AudioChatActions.resetTranscript());
}

function* scenarioPlayerSaga() {
  yield all([
    takeEvery(ScenarioPlayerActions.restartScenario, resetTranscriptSaga),
  ]);
}

export default scenarioPlayerSaga;
